(function() {
  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  function isCollectionUrl(url) {
    return url.origin === window.location.origin && /^\/collections\/[^/?#]+\/?$/.test(url.pathname);
  }

  function isProductCollectionUrl(url, link) {
    var handle = '';
    try {
      handle = decodeURIComponent(url.pathname.split('/collections/')[1] || '').toLowerCase();
    } catch (error) {
      handle = (url.pathname.split('/collections/')[1] || '').toLowerCase();
    }

    var text = '';
    if (link && link.textContent) text = link.textContent.trim().toLowerCase();

    return /(^|[-_])products?($|[-_])/.test(handle) ||
      handle.indexOf('products') !== -1 ||
      handle.indexOf('商品') !== -1 ||
      text.indexOf('products') !== -1 ||
      (text.indexOf('商品') !== -1 && text.indexOf('單卡') === -1);
  }

  function shouldRouteMobileCollection(url, link) {
    return isCollectionUrl(url);
  }

  function mobileCollectionUrl(url) {
    var next = new URL(url.href);
    next.searchParams.set('view', 'mobile-v3');
    next.searchParams.set('page', '1');
    return next.pathname + next.search + next.hash;
  }

  function routeMobileCollections(root) {
    if (!isMobile()) return;
    root = root || document;

    root.querySelectorAll('a[href]').forEach(function(link) {
      try {
        var url = new URL(link.getAttribute('href'), window.location.origin);
        if (!shouldRouteMobileCollection(url, link) || url.searchParams.get('view') === 'mobile-v3') return;
        link.setAttribute('href', mobileCollectionUrl(url));
      } catch (error) {}
    });
  }

  function redirectCurrentCollection() {
    if (!isMobile()) return;

    try {
      var current = new URL(window.location.href);
      if (!shouldRouteMobileCollection(current, null) || current.searchParams.get('view') === 'mobile-v3') return;
      window.location.replace(mobileCollectionUrl(current));
    } catch (error) {}
  }

  function disableMobileFacebookFrame(root) {
    if (!isMobile()) return;
    root = root || document;

    root.querySelectorAll('[data-fb-page-wrapper]').forEach(function(wrapper) {
      if (wrapper.dataset.bgtcgMobileFallback === 'true') return;
      wrapper.dataset.bgtcgMobileFallback = 'true';
      wrapper.innerHTML = '<div class="fb-plugin-fallback">Facebook 動態未能載入。<br><a href="https://www.facebook.com/battleground.hk" target="_blank" rel="noopener noreferrer">開啟 Battleground Facebook 專頁</a></div>';
    });
  }

  function applyMobileSafeguards(root) {
    routeMobileCollections(root);
    disableMobileFacebookFrame(root);
  }

  function refreshHotPreorderSection() {
    var sectionId = 'template--20151597301869__featured_collection_aAWVmF';
    var section = document.getElementById('shopify-section-' + sectionId);
    if (!section || section.querySelector('.bgtcg-qty-wrap') || window.__bgtcgHotPreorderRefresh) return;

    window.__bgtcgHotPreorderRefresh = true;
    fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
      .then(function(response) { return response.ok ? response.json() : null; })
      .then(function(payload) {
        var html = payload && payload[sectionId];
        if (!html) return;

        var wrapper = document.createElement('div');
        wrapper.innerHTML = html;
        var freshSection = wrapper.querySelector('#shopify-section-' + sectionId);
        if (freshSection && freshSection.querySelector('.bgtcg-qty-wrap')) section.replaceWith(freshSection);
      })
      .catch(function() {});
  }

  redirectCurrentCollection();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      applyMobileSafeguards();
      refreshHotPreorderSection();
    });
  } else {
    applyMobileSafeguards();
    refreshHotPreorderSection();
  }

  document.addEventListener('click', function(event) {
    if (!isMobile()) return;

    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;

    try {
      var url = new URL(link.getAttribute('href'), window.location.origin);
      if (!shouldRouteMobileCollection(url, link) || url.searchParams.get('view') === 'mobile-v3') return;
      event.preventDefault();
      window.location.assign(mobileCollectionUrl(url));
    } catch (error) {}
  }, true);

  if ('MutationObserver' in window) {
    new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) applyMobileSafeguards(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
